import { render, staticRenderFns } from "./HeadToHead.vue?vue&type=template&id=250c0663&scoped=true"
import script from "./HeadToHead.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeadToHead.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeadToHead.vue?vue&type=style&index=0&id=250c0663&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c0663",
  null
  
)

export default component.exports